import { render } from "./PageActions.vue?vue&type=template&id=2740c10f&scoped=true"
import script from "./PageActions.vue?vue&type=script&lang=js"
export * from "./PageActions.vue?vue&type=script&lang=js"

import "./PageActions.vue?vue&type=style&index=0&id=2740c10f&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2740c10f"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
